import { render, staticRenderFns } from "./Tomador.vue?vue&type=template&id=fbeb0502"
import script from "./Tomador.vue?vue&type=script&lang=js"
export * from "./Tomador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports